{
  "app.name": "404 OS",
  "app.tagline": "نظام تشغيل 404 Creative",
  "auth.signIn.title": "سجّل دخولك إلى 404 OS",
  "auth.signIn.subtitle": "مخصص لفريق 404 Creative.",
  "auth.email": "البريد الإلكتروني للعمل",
  "auth.password": "كلمة المرور",
  "auth.showPassword": "إظهار كلمة المرور",
  "auth.hidePassword": "إخفاء كلمة المرور",
  "auth.submit": "تسجيل الدخول",
  "auth.submitting": "جارٍ تسجيل الدخول…",
  "auth.signOut": "تسجيل الخروج",
  "auth.errors.email": "اكتب بريداً إلكترونياً صحيحاً.",
  "auth.errors.password": "اكتب كلمة المرور.",
  "auth.brand.headline": "كل عميل ومشروع ومهمة في مكان واحد هادئ.",
  "auth.brand.point1": "خطّط في محطات، لكلٍّ منها مراحلها الخاصة.",
  "auth.brand.point2": "اعرف ما يعمل عليه كل فرد في الفريق دون أن تسأل.",
  "auth.brand.point3": "أبقِ العملاء على اطلاع دائم، وكل موافقة موثّقة.",
  "nav.myWork": "مهامي",
  "nav.projects": "المشاريع",
  "nav.clients": "العملاء",
  "nav.group.work": "العمل",
  "nav.group.agency": "الوكالة",
  "nav.group.sales": "المبيعات",
  "topbar.search": "ابحث أو انتقل إلى…",
  "topbar.switchLanguage": "English",
  "topbar.accountMenu": "قائمة الحساب",
  "header.language": "اللغة",
  "role.owner": "المالك",
  "role.admin": "مدير النظام",
  "role.finance": "الحسابات",
  "role.pm": "مدير مشروع",
  "role.member": "عضو فريق",
  "role.contractor": "متعاون خارجي",
  "service.web": "الويب والمتاجر",
  "service.mobile": "تطبيقات الموبايل",
  "service.automation": "الأتمتة والذكاء الاصطناعي",
  "service.marketing": "تسويق النمو",
  "projects.title": "المشاريع",
  "projects.subtitle": "كل ما يعمل عليه الفريق الآن.",
  "projects.new": "مشروع جديد",
  "projects.empty.title": "لا توجد مشاريع بعد",
  "projects.empty.body": "أنشئ أول مشروع لتبدأ تخطيط المهام مع الفريق.",
  "projects.loadError": "تعذّر تحميل المشاريع.",
  "newProject.title": "مشروع جديد",
  "newProject.description": "المشروع يجمع المهام والفريق والفلوس الخاصة بتعاقد واحد مع عميل.",
  "newProject.name": "اسم المشروع",
  "newProject.namePlaceholder": "إعادة تصميم متجر نون",
  "newProject.key": "رمز المشروع",
  "newProject.service": "الخدمة",
  "newProject.create": "إنشاء المشروع",
  "newProject.creating": "جارٍ الإنشاء…",
  "newProject.created": "تم إنشاء المشروع {key}.",
  "newProject.errors.name": "اكتب حرفين على الأقل.",
  "newProject.errors.key": "استخدم من 2 إلى 10 حروف إنجليزية أو أرقام تبدأ بحرف.",
  "board.status.backlog": "لاحقًا",
  "board.status.todo": "للتنفيذ",
  "board.status.in_progress": "قيد التنفيذ",
  "board.status.in_review": "قيد المراجعة",
  "board.status.done": "تم",
  "board.status.cancelled": "ملغي",
  "board.addTask": "إضافة مهمة",
  "board.addTaskPlaceholder": "ما المطلوب إنجازه؟",
  "board.addTaskHint": "Enter للإضافة · Esc للإلغاء",
  "board.moveError": "تغيّرت اللوحة أثناء نقل المهمة، فتم تحديثها.",
  "board.loadError": "تعذّر تحميل هذه اللوحة.",
  "board.dnd.instructions": "لالتقاط مهمة اضغط مسافة. استخدم السهمين الأيمن والأيسر لنقلها إلى عمود آخر، والسهمين لأعلى ولأسفل لإعادة ترتيبها، ثم اضغط مسافة لإفلاتها، أو Escape للإلغاء. اضغط Enter لفتحها.",
  "board.dnd.picked": "تم التقاط {title}.",
  "board.dnd.over": "{title} فوق {column}.",
  "board.dnd.dropped": "تم إفلات {title} في {column}.",
  "board.dnd.cancelled": "تم إلغاء نقل {title}.",
  "palette.title": "لوحة الأوامر",
  "palette.placeholder": "اكتب أمراً أو ابحث…",
  "palette.empty": "لا توجد نتائج.",
  "palette.navigation": "انتقل إلى",
  "palette.projects": "المشاريع",
  "palette.actions": "إجراءات",
  "palette.newProject": "إنشاء مشروع جديد",
  "palette.newTask": "إنشاء مهمة جديدة",
  "palette.switchLanguage": "التبديل إلى الإنجليزية",
  "palette.signOut": "تسجيل الخروج",
  "common.retry": "حاول مرة أخرى",
  "common.cancel": "إلغاء",
  "common.close": "إغلاق",
  "date.pick": "اختر تاريخًا",
  "errors.generic": "حدث خطأ. حاول مرة أخرى.",
  "errors.network": "تعذّر الوصول إلى الخادم. تحقق من اتصالك.",
  "errors.notFound.title": "الصفحة غير موجودة",
  "errors.notFound.body": "الصفحة التي تبحث عنها غير موجودة أو تم نقلها.",
  "errors.notFound.home": "اذهب إلى المشاريع",
  "auth.errors.invalid": "البريد الإلكتروني أو كلمة المرور غير صحيحة.",
  "newProject.errors.keyTaken": "يوجد مشروع آخر يستخدم هذا الرمز.",
  "shell.skipToContent": "تخطَّ إلى المحتوى",
  "shell.mainNavigation": "التنقل الرئيسي",
  "shell.collapseSidebar": "طيّ القائمة الجانبية",
  "shell.expandSidebar": "فتح القائمة الجانبية",
  "palette.open": "فتح لوحة الأوامر",
  "board.columnTasks": "{column}: {count, plural, =0 {لا توجد مهام} one {مهمة واحدة} two {مهمتان} few {# مهام} many {# مهمة} other {# مهمة}}",
  "errors.unexpected.body": "توقفت هذه الصفحة بسبب خطأ غير متوقع. أعد التحميل للمحاولة مرة أخرى.",
  "shell.openMenu": "فتح القائمة",
  "shell.breadcrumb": "مسار التنقل",
  "shell.moreTabs": "المزيد",
  "palette.hintMove": "للتنقل",
  "palette.hintOpen": "للفتح",
  "projects.stats.active": "المشاريع النشطة",
  "projects.stats.open": "المهام المفتوحة",
  "projects.stats.progress": "نسبة الإنجاز الكلية",
  "projects.filter.label": "تصفية حسب الخدمة",
  "projects.search": "ابحث في المشاريع",
  "projects.columns.project": "المشروع",
  "projects.columns.progress": "الإنجاز",
  "projects.columns.open": "مفتوحة",
  "projects.progress": "تم إنجاز {done, number} من {total, number}",
  "projects.noResults.title": "لا توجد مشاريع مطابقة",
  "projects.noResults.body": "جرّب اسماً أو رمزاً أو خدمة أخرى.",
  "projects.noResults.clear": "مسح الفلاتر",
  "project.tabs.label": "عروض المشروع",
  "project.tabs.board": "اللوحة",
  "project.tabs.overview": "نظرة عامة",
  "project.newTask": "مهمة جديدة",
  "project.ownTasksOnly": "مهامك فقط",
  "project.ownTasksOnly.hint": "في هذا المشروع ترى المهام التي أنشأتها أو المُسندة إليك. التقدم يحسب المشروع كله.",
  "project.status.active": "نشط",
  "project.status.on_hold": "متوقف",
  "project.status.completed": "مكتمل",
  "project.status.archived": "مؤرشف",
  "overview.progress.title": "التقدم",
  "overview.breakdown.title": "المهام حسب الحالة",
  "overview.recent.title": "آخر التحديثات",
  "overview.recent.empty": "ستظهر هنا المهام التي تضيفها.",
  "overview.details.title": "التفاصيل",
  "overview.details.key": "الرمز",
  "overview.details.status": "الحالة",
  "task.dialogLabel": "المهمة {reference}",
  "task.titleLabel": "عنوان المهمة",
  "task.properties": "الخصائص",
  "task.status": "الحالة",
  "task.project": "المشروع",
  "task.noProject": "بدون مشروع",
  "task.moveToProject.action": "نقل إلى مشروع",
  "task.moveToProject.title": "نقل {reference} إلى مشروع",
  "task.moveToProject.body": "ستأخذ الرقم التالي في المشروع، وتنتقل معها مهامها الفرعية وتعليقاتها وسجلّها.",
  "task.moveToProject.confirm": "نقل المهمة",
  "task.moveToProject.moving": "جارٍ النقل…",
  "task.moveToProject.done": "تم النقل. أصبح رقم المهمة {reference}.",
  "task.moveToProject.notMembers": "أحد المكلَّفين بهذه المهمة ليس عضواً في ذلك المشروع. أضِفه إلى المشروع أو ألغِ تكليفه أولاً.",
  "task.moveToProject.forbidden": "لا يمكنك إضافة مهام إلى ذلك المشروع.",
  "task.projectPicker.choose": "اختر مشروعاً",
  "task.projectPicker.search": "ابحث في المشاريع",
  "task.projectPicker.empty": "لا يوجد مشروع مطابق.",
  "task.projectPicker.none": "لا يوجد بعد مشروع يمكنك إضافة مهام إليه.",
  "task.created": "تاريخ الإنشاء",
  "task.updated": "آخر تحديث",
  "task.completed": "تاريخ الإنجاز",
  "task.copyLink": "نسخ الرابط",
  "task.linkCopied": "تم نسخ الرابط.",
  "task.notFound": "هذه المهمة لم تعد موجودة.",
  "task.close": "إغلاق المهمة",
  "task.changeStatus": "تغيير الحالة",
  "newTask.title": "مهمة جديدة",
  "newTask.description": "أضفها إلى اللوحة، ويمكنك نقلها في أي وقت.",
  "newTask.descriptionAnywhere": "ضعها في مشروع، أو اتركها خارج المشاريع الآن وانقلها لاحقاً.",
  "newTask.projectLabel": "المشروع",
  "newTask.titleLabel": "العنوان",
  "newTask.statusLabel": "الحالة",
  "newTask.create": "إنشاء المهمة",
  "newTask.creating": "جارٍ الإنشاء…",
  "newTask.created": "تم إنشاء المهمة {reference}.",
  "newTask.errors.title": "اكتب عنواناً للمهمة.",
  "auth.preview.label": "لوحة مشروع في 404 OS",
  "auth.preview.project": "إعادة تصميم المتجر",
  "auth.preview.task1": "تصميم الصفحة الرئيسية",
  "auth.preview.task2": "أتمتة طلبات واتساب",
  "auth.preview.task3": "خطة إطلاق إعلانات ميتا",
  "auth.preview.task4": "مراجعة البريف مع العميل",
  "board.addTaskTo": "إضافة مهمة إلى {column}",
  "task.open": "فتح",
  "task.conflict": "عدّل شخص آخر هذه المهمة فتم تحديثها. حاول مرة أخرى.",
  "task.notFoundBody": "ربما حُذفت، أو أن الرابط غير مكتمل.",
  "overview.details.service": "الخدمة",
  "overview.details.created": "تاريخ الإنشاء",
  "overview.details.tasks": "المهام",
  "project.notFound.title": "المشروع غير موجود",
  "project.notFound.body": "ربما تغيّر رمزه، أو ليس لديك صلاحية الوصول إليه.",
  "project.loadError": "تعذّر تحميل هذا المشروع.",
  "common.copy": "نسخ",
  "common.copied": "تم النسخ",
  "common.copiedToast": "تم النسخ إلى الحافظة.",
  "common.copyFailed": "تعذّر النسخ. حدّد النص وانسخه يدوياً.",
  "combobox.clear": "إزالة الاختيار",
  "errors.invalidValue": "لم تُقبل هذه القيمة. راجعها وحاول مرة أخرى.",
  "errors.validation": "لم تُقبل بعض البيانات. راجعها وحاول مرة أخرى.",
  "errors.forbidden": "ليست لديك صلاحية للقيام بذلك.",
  "errors.conflict": "عدّل شخص آخر هذه البيانات في هذه الأثناء. أعد التحميل وحاول مرة أخرى.",
  "theme.title": "المظهر",
  "theme.system": "حسب النظام",
  "theme.light": "فاتح",
  "theme.dark": "داكن",
  "palette.theme.system": "اتباع مظهر النظام",
  "palette.theme.light": "التبديل إلى المظهر الفاتح",
  "palette.theme.dark": "التبديل إلى المظهر الداكن",
  "palette.theme.current": "(الحالي)",
  "auth.help": "تواجه مشكلة في الدخول؟ اسأل من دعاك إلى 404 OS.",
  "auth.reset.forgot": "نسيت كلمة المرور؟",
  "auth.reset.title": "إعادة تعيين كلمة المرور",
  "auth.reset.subtitle": "اكتب البريد الإلكتروني الذي تستخدمه للدخول. إن كان على 404 OS فسنرسل رمزاً من أربعة أرقام.",
  "auth.reset.submit": "إرسال الرمز",
  "auth.reset.submitting": "جارٍ الإرسال…",
  "auth.reset.back": "العودة لتسجيل الدخول",
  "auth.reset.sentTitle": "تحقق من بريدك",
  "auth.reset.sentSubtitle": "أدخل الرمز المكوّن من أربعة أرقام الذي أرسلناه إلى {email}.",
  "auth.reset.codeLabel": "رمز التحقق",
  "auth.reset.digit": "الرقم {position}",
  "auth.reset.verifying": "جارٍ التحقق…",
  "auth.reset.resend": "إرسال رمز جديد",
  "auth.reset.resendIn": "إعادة الإرسال خلال {seconds} ث",
  "auth.reset.newTitle": "اختر كلمة مرور جديدة",
  "auth.reset.newSubtitle": "بعدها ستُسجَّل دخولك، وتُسجَّل خروجك من أجهزتك الأخرى.",
  "auth.reset.newSubmit": "حفظ كلمة المرور والدخول",
  "auth.reset.newSubmitting": "جارٍ الحفظ…",
  "auth.reset.confirm": "تأكيد كلمة المرور",
  "auth.reset.errors.otp": "هذا الرمز غير صالح. تأكد منه وحاول مرة أخرى.",
  "auth.reset.errors.rateLimited": "محاولات كثيرة. انتظر بضع دقائق ثم حاول مرة أخرى.",
  "auth.reset.errors.mismatch": "كلمتا المرور غير متطابقتين.",
  "auth.reset.errors.length": "استخدم ١٠ أحرف على الأقل.",
  "auth.preview.task5": "دليل الهوية البصرية",
  "auth.preview.doneThisWeek": "أُنجز هذا الأسبوع",
  "auth.preview.toast": "نقلت نور «أتمتة طلبات واتساب» إلى قيد المراجعة",
  "errors.notFound.search": "ابحث في 404 OS",
  "errors.unexpected.title": "توقفت هذه الصفحة عن العمل",
  "errors.unexpected.home": "العودة إلى الرئيسية",
  "realtime.live": "مباشر",
  "realtime.connecting": "جارٍ الاتصال",
  "realtime.offline": "غير متصل",
  "realtime.liveHint": "تظهر تغييرات فريقك لحظة حدوثها",
  "realtime.connectingHint": "جارٍ الاتصال بالتحديثات المباشرة",
  "realtime.offlineHint": "التحديثات المباشرة متوقفة مؤقتًا، ونواصل المحاولة في الخلفية.",
  "reason.label": "السبب",
  "reason.tooShort": "اكتب سببًا من {min} حروف على الأقل.",
  "changeStamp.by": "عدّلها {name} · {when}",
  "dataTable.sortBy": "رتّب حسب {column}",
  "dataTable.selectAll": "اختيار كل الصفوف",
  "dataTable.selectRow": "اختيار {name}",
  "role.hr": "الموارد البشرية"
}
